
export function convertFileSizeToKB(size) {
    let fileSizeInKB = (size / 1024);
    return Math.round(fileSizeInKB * 100) / 100;
}

export function convertFileSizeToMB(size) {
    let fileSizeInMB = (size / 1024) / 1024;
    return Math.round(fileSizeInMB * 100) / 100;
}